module.exports = __webpack_public_path__ + "static/media/RI-D1-7.3-073.c0018a4b.webp";